import * as React from 'react';
import debounce from 'lodash/debounce';

/** Debounce options forwarded to lodash
 *  https://lodash.com/docs/4.17.15#debounce
 */
export type DebounceOptions = {
  leading: boolean;
  maxWait: number;
  trailing: boolean;
};

export function useDebouncedEffect(
  effectToDebounce: () => void,
  deps: Array<unknown> = [],
  wait: number = 0,
  debounceOptions?: DebounceOptions
): void {
  const debouncedEffect = React.useCallback(
    debounce(effectToDebounce, wait, debounceOptions),
    // eslint-disable-next-line react-hooks/react-compiler -- pre-ratchet baseline (BLOOP-3033)
    deps
  );

  React.useEffect(() => {
    debouncedEffect();

    return () => {
      debouncedEffect.cancel();
    };
  }, [debouncedEffect]);
}
